import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SLICE_BASE_NAME } from './constants'

export type UserState = {
   avatar?: string
   userName?: string
   email?: string
   onlyBackup: boolean
   roles?: string[]
   partyIdentification?: string
   fullName?: string
   authority: string[]
   isAccountant?: boolean
}

const initialState: UserState = {
   avatar: '',
   userName: '',
   onlyBackup: false,
   email: '',
   roles: [],
   authority: ['ADMIN'],
}

const userSlice = createSlice({
   name: `${SLICE_BASE_NAME}/user`,
   initialState,
   reducers: {
      setUser(state, action: PayloadAction<UserState>) {
         // state.avatar = action.payload?.avatar
         state.email = action.payload?.email
         state.userName = action.payload?.userName
         state.roles = action.payload?.roles
         state.fullName = action.payload?.fullName
         state.partyIdentification = action.payload?.partyIdentification
         state.onlyBackup = action.payload?.onlyBackup
         state.isAccountant = action.payload?.isAccountant
      },
   },
})

export const { setUser } = userSlice.actions
export default userSlice.reducer
